import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import FormHelperText from "@material-ui/core/FormHelperText";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";

const styles = (theme) => ({
  formControl: {
    marginBottom: 10,
    minWidth: 250,
  },
  textField: {
    margin: theme.spacing(1),
  },
  labelInput: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});
class CreateCustomField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customField: { value: "" },
      propertyValues: [],
      propertyValueTemp: "",
      duplicateError: false,
      dateSettings: {
        minimum: false,
        maximum: false,
        minimumValue: null,
        maximumValue: null,
      },
    };
  }
  componentDidMount() {
    if (this.props.editInEditor) {
      this.setState({
        customField: this.props.selectedForEdit,
      });
      if (
        this.props.selectedForEdit.fieldType === "select" ||
        this.props.selectedForEdit.fieldType === "multiselect"
      ) {
        this.setState({
          propertyValues: JSON.parse(this.props.selectedForEdit.propertyValues),
        });
      }
    }
    if (
      (this.props.index || this.props.index === 0) &&
      this.props.selectedForEdit
    ) {
      if (this.props.selectedForEdit.propertyValues) {
        let propertyValues = JSON.parse(this.props.selectedForEdit.propertyValues) 
        let dateSettings = {
          minimum: propertyValues.minimum ? propertyValues.minimum : false,
          maximum: propertyValues.maximum ? propertyValues.maximum : false,
          minimumValue: propertyValues.minimumValue ? propertyValues.minimumValue : null,
          maximumValue: propertyValues.maximumValue ? propertyValues.maximumValue : null,
        }
        this.setState({
          customField: this.props.selectedForEdit,
          propertyValues: propertyValues,
          dateSettings: dateSettings,
        });
      } else {
        this.setState({ customField: this.props.selectedForEdit });
      }
    }
  }
  render() {
    const { classes, t } = this.props;
    return (
      <>
      {(this.props.selectedForEdit === null || this.state.customField.name) &&
          <div>
            <DialogTitle>
              <Trans i18nKey="add_new_custom_field" />
            </DialogTitle>
            <DialogContent
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                height: "100%",
              }}
            >
              <FormControl className={classes.formControl}>
                <TextField
                  fullWidth
                  required
                  label="Label"
                  value={this.state.customField.name}
                  onChange={this.updateName}
                  margin="normal"
                  aria-label="Custom field label"
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={(event) =>
                        this.setState({
                          customField: {
                            ...this.state.customField,
                            mandatory: event.target.checked,
                          },
                        })
                      }
                      checked={this.state.customField.mandatory}
                    />
                  }
                  label={t("global_mandatory")}
                />
              </FormControl>
              {!this.props.editInEditor && (
                <FormControl className={classes.formControl}>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={this.state.customField.fieldType}
                    onChange={this.handleTypeChange}
                    aria-label="Custom field type select"
                  >
                    <MenuItem value="input">
                      <Trans i18nKey="global_input" />
                    </MenuItem>
                    <MenuItem value="select">
                      <Trans i18nKey="global_select" />
                    </MenuItem>
                    <MenuItem value="multiselect">Multiselect</MenuItem>
                    <MenuItem value="date">Date</MenuItem>
                  </Select>
                </FormControl>
              )}
              <FormControl className={classes.formControl}>
                {this.state.customField.fieldType === "input" ? (
                  <TextField
                    fullWidth
                    label="Value"
                    value={this.state.customField.value}
                    onChange={this.updateValue}
                    margin="normal"
                    aria-label="Custom field Text input"
                  />
                ) : this.state.customField.fieldType === "select" ||
                this.state.customField.fieldType === "multiselect" ? (
                  <div>
                    {this.state.propertyValues.map((name, idx) => (
                      <Chip
                        key={idx}
                        label={name}
                        style={{ margin: 2 }}
                        onDelete={this.handleDelete.bind(this, name)}
                      />
                    ))}
                    <div className={classes.labelInput}>
                      <TextField
                        fullWidth
                        label="Option name"
                        value={this.state.propertyValueTemp}
                        onChange={this.updatePropertyValue}
                        margin="normal"
                        aria-label="Selection option text input"
                        error={this.state.duplicateError}
                      />
                      {this.state.duplicateError && (
                        <FormHelperText
                          error
                          className={classes.textField}
                          id="component-error-text"
                        >
                          <Trans i18nKey="custom_fields_duplicate_label" />
                        </FormHelperText>
                      )}

                      <Button
                        variant="contained"
                        color="primary"
                        aria-label="Selection option add button"
                        onClick={this.addPropertyValue}
                      >
                        <Trans i18nKey="global_add" />
                      </Button>
                    </div>
                    {this.state.propertyValues.length > 1 && (
                      <FormControl className={classes.formControl}>
                        <InputLabel>
                          <Trans i18nKey="default_value" />{" "}
                        </InputLabel>
                        <Select
                          // style={{ zIndex: 4000 }}
                          aria-label="Default select value"
                          multiple={
                            this.state.customField.fieldType === "multiselect"
                          }
                          value={
                            !this.state.customField.value
                              ? []
                              : this.state.customField.fieldType === "multiselect"
                                ? JSON.parse(this.state.customField.value)
                                : this.state.customField.value
                          }
                          onChange={(e) =>
                            this.handleSelectValueChange(
                              this.state.customField.fieldType === "multiselect"
                                ? JSON.stringify(e.target.value)
                                : e.target.value
                            )
                          }
                        >
                          {this.state.propertyValues.map((name, idx) => (
                            <MenuItem key={idx} value={name} aria-label={name}>
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                ) : (
                  this.state.customField.fieldType === "date" && (
                    <>
                      <FormControlLabel
                        aria-label="Minimum date restriction"
                        control={
                          <Checkbox
                            onClick={(event) =>
                              this.setState({
                                dateSettings: {
                                  ...this.state.dateSettings,
                                  minimum: event.target.checked,
                                  minimumValue: null,
                                },
                              })
                            }
                            checked={this.state.dateSettings.minimum}
                          />
                        }
                        label={"Minimum restriction"}
                      />
                      {this.state.dateSettings.minimum && (
                        <DatePicker
                          maxDate={this.state.dateSettings.maximum ? moment(this.state.dateSettings.maximumValue) :new Date("2900-01-01") }
                          autoOk
                          label={t("filter_documents_created_after")}
                          clearable
                          aria-label="Date default value picker"
                          value={
                            this.state.dateSettings.minimumValue
                          }
                          onChange={(date) =>
                            this.setState({
                              dateSettings: {
                                ...this.state.dateSettings,
                                minimumValue: date,
                              },
                            })
                          }
                        />
                      )}
                      <FormControlLabel
                        aria-label="Maximum date restriction"
                        control={
                          <Checkbox
                            onClick={(event) =>
                              this.setState({
                                dateSettings: {
                                  ...this.state.dateSettings,
                                  maximum: event.target.checked,
                                  maximumValue: null,
                                },
                              })
                            }
                            checked={this.state.dateSettings.maximum}
                          />
                        }
                        label={"Maximum restriction"}
                      />
                      {this.state.dateSettings.maximum && (
                        <DatePicker
                          minDate={
                            this.state.dateSettings.minimum ?
                            moment(this.state.dateSettings.minimumValue)
                            :new Date("1900-01-01")
                          }
                          autoOk
                          label={t("filter_documents_created_before")}
                          clearable
                          value={
                            this.state.dateSettings.maximumValue
                          }
                          onChange={(date) =>
                            this.setState({
                              dateSettings: {
                                ...this.state.dateSettings,
                                maximumValue: date,
                              },
                            })
                          }
                        />
                      )}
                      <DatePicker
                        minDate={this.state.dateSettings.minimum ? moment(this.state.dateSettings.minimumValue): new Date("1900-01-01")}
                        maxDate={this.state.dateSettings.maximum ? moment(this.state.dateSettings.maximumValue) :new Date("2900-01-01")}
                        autoOk
                        label={"Value"}
                        clearable
                        value={
                          this.state.customField.value
                            ? moment(this.state.customField.value)
                            : null
                        }
                        onChange={(date) =>
                          this.setState({
                            customField: {
                              ...this.state.customField,
                              value: date,
                            },
                          })
                        }
                      />
                    </>
                  )
                )}
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={this.props.close}
              >
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button
                disabled={
                  !this.state.customField.fieldType || !this.state.customField.name
                }
                variant="contained"
                color="primary"
                onClick={this.addCustomField}
              >
                <Trans i18nKey="save" />
              </Button>
            </DialogActions>
          </div>
      }
      </>
    );
  }

  handleDelete = (e) => {
    this.setState({
      propertyValues: this.state.propertyValues.filter((property) => {
        return property !== e;
      }),
    });
  };
  handleSelectValueChange = (e) => {
    this.setState({
      customField: { ...this.state.customField, value: e },
    });
  };
  updateName = (title) => {
    this.setState({
      customField: { ...this.state.customField, name: title.target.value },
    });
  };
  handleTypeChange = (e) => {
    this.setState({
      customField: { ...this.state.customField, fieldType: e.target.value },
    });
  };
  updateValue = (value) => {
    this.setState({
      customField: { ...this.state.customField, value: value.target.value },
    });
  };
  updatePropertyValue = (value) => {
    this.setState({ propertyValueTemp: value.target.value });
  };
  addPropertyValue = (value) => {
    if (
      this.state.propertyValues.includes(this.state.propertyValueTemp) === false
    ) {
      this.setState({
        propertyValues: [
          ...this.state.propertyValues,
          this.state.propertyValueTemp,
        ],
        propertyValueTemp: "",
        duplicateError: false,
      });
    } else {
      this.setState({ duplicateError: true });
    }
  };
  addCustomField = () => {
    let customFieldsRVO = this.state.customField;
    if (
      customFieldsRVO.fieldType === "select" ||
      customFieldsRVO.fieldType === "multiselect"
    ) {
      customFieldsRVO.propertyValues = JSON.stringify(
        this.state.propertyValues
      );
    } else if (customFieldsRVO.fieldType === "date") {
      customFieldsRVO.propertyValues = JSON.stringify(this.state.dateSettings);
    }
    if (this.props.editInEditor) {
      this.props.editCustomField(customFieldsRVO, this.props.index);
    } else if (
      (this.props.index || this.props.index === 0) &&
      this.props.selectedForEdit
    ) {
      this.props.editCustomField(customFieldsRVO, this.props.index);
    } else {
      this.props.addCustomField(customFieldsRVO);
    }
  };
}
export default withTranslation()(withStyles(styles)(CreateCustomField));
